import {Button, ButtonProps} from '@mui/material';
import React from 'react';
import {ShowIfDebugWrapper} from '../contexts/DebugProvider';
import {FeatureBoundary} from '../contexts/FeatureBoundary';
import {GlobalPermissionEnum} from '../schema-types/globalTypes';
import {DjangoContextType, useDjangoContext} from '../contexts/useAuthContext';

type curoType =
  | 'account'
  | 'review'
  | 'recommendation'
  | 'goal'
  | 'plan'
  | 'contact'
  | 'systemuser'
  | 'home';

export const getCuroURL = (
  loggedInUser: DjangoContextType['djangoUser'], // requires details of the logged in user so this can never be accidentally fetched
  type: curoType,
  curoId: string | null
) => {
  if (
    // if they cannot access curo, dont show link
    !loggedInUser.perms?.find(
      (x) => x?.codename === GlobalPermissionEnum.can_access_curo_FE
    )
  ) {
    return '';
  }
  const domain = process.env.VITE_APP_CURO_DOMAIN;

  if (type === 'account') {
    return `${domain}/main.aspx?etc=1&extraqs=formid%3d655886cc-508c-4fea-828a-f87eab97ed14&id=%7b${curoId}%7d&pagetype=entityrecord`;
  }
  if (type === 'review') {
    return `${domain}/main.aspx?etc=10066&extraqs=formid%3d8ec8d520-9703-47ab-8ce0-5b63a099d1e3&id=%7b${curoId}%7d&pagetype=entityrecord`;
  }
  // saltusuat.curo3uat.net/main.aspx?etc=10066&extraqs=formid%3d8ec8d520-9703-47ab-8ce0-5b63a099d1e3&id=%7b8189c3b4-32a2-ed11-a860-000d3a7ef302%7d&pagetype=entityrecord#579595655
  // https://saltusuat.curo3uat.net/main.aspx?etc=10066&extraqs=formid%3d8ec8d520-9703-47ab-8ce0-5b63a099d1e3&id=%7b8189c3b4-32a2-ed11-a860-000d3a7ef302%7d&pagetype=entityrecord#579595655
  // https://saltusuat.curo3uat.net/main.aspx?etn=t4a_curorecommendation&pagetype=entityrecord&id=%7BECEC1CC2-AEA3-ED11-A860-000D3A7EF302%7D#802032438
  if (type === 'recommendation') {
    return `${domain}/main.aspx?etn=t4a_curorecommendation&pagetype=entityrecord&id=%7B${curoId}%7D#802032438`;
    // return `${domain}/main.aspx?etc=10066&extraqs=formid%3d8ec8d520-9703-47ab-8ce0-5b63a099d1e3&id=%7b${curoId}%7d&pagetype=entityrecord#579595655`;
  }
  if (type === 'plan') {
    return `${domain}/main.aspx?etn=t4a_curoholding&pagetype=entityrecord&id=%7B${curoId}%7D`;
    // return `${domain}/main.aspx?etc=10066&extraqs=formid%3d8ec8d520-9703-47ab-8ce0-5b63a099d1e3&id=%7b${curoId}%7d&pagetype=entityrecord#579595655`;
  }
  if (type === 'contact') {
    return `${domain}/main.aspx?etn=contact&pagetype=entityrecord&id=%7B${curoId}%7D`;
    // return `${domain}/main.aspx?etc=10066&extraqs=formid%3d8ec8d520-9703-47ab-8ce0-5b63a099d1e3&id=%7b${curoId}%7d&pagetype=entityrecord#579595655`;
  }
  if (type === 'goal') {
    return `${domain}/main.aspx?etn=t4a_planningobjective&pagetype=entityrecord&id=%7B${curoId}%7D#802032438`;
  }
  if (type === 'systemuser') {
    return `${domain}/main.aspx?etn=systemuser&id={${curoId}}&pagetype=entityrecord#788259240`;
  }
  if (type === 'home') {
    return domain;
  }
};

export const OpenInCuro: React.FC<
  ButtonProps & {
    curoType: curoType;
    curoId?: string | null;
    alwaysShow?: boolean;
  }
> = ({curoType, alwaysShow, curoId, children, ...buttonProps}) => {
  const {djangoUser} = useDjangoContext();
  if (!curoId) {
    return null;
  }
  if (alwaysShow) {
    return (
      <FeatureBoundary
        showErrorIfDenied={false}
        features={[GlobalPermissionEnum.can_access_curo_FE]}
      >
        <Button
          onClick={() => {
            window.open(getCuroURL(djangoUser, curoType, curoId), '_blank');
          }}
          {...buttonProps}
        >
          {children || 'Curo'}
        </Button>
      </FeatureBoundary>
    );
  }
  return (
    <FeatureBoundary
      showErrorIfDenied={false}
      features={[GlobalPermissionEnum.can_access_curo_FE]}
    >
      <ShowIfDebugWrapper debugKey="forms">
        <Button
          onClick={() => {
            window.open(getCuroURL(djangoUser, curoType, curoId), '_blank');
          }}
          {...buttonProps}
        >
          {children || 'Curo'}
        </Button>
      </ShowIfDebugWrapper>
    </FeatureBoundary>
  );
};

export const getPowerBIURL = (curoId: string) => {
  return `https://app.powerbi.com/reportEmbed?reportId=ca164764-0f0e-4455-a62e-ba76bfa5052e&autoAuth=true&pageName=ReportSection32c8e9bd05af30843e02&$filter=curoAccounts/AccountId eq '${curoId}'`;
};
